import { Icon } from '@virtidev/toolbox';
import styled, { css } from 'styled-components';

export const ObjectiveGroupWrapper = styled.div``;
export const ObjectiveGroup = styled.div`
  display: flex;
  position: relative;
`;
export const ObjectiveGroupHint = styled.div``;
export const Objective = styled.div``;
export const HintButton = styled.button`
  position: absolute;
  right: 0;
  border-radius: 60px;
  width: 40px;
  height: 40px;
  margin-top: 4px;
  border: none;
  color: var(--pd-neutral-color);
  cursor: pointer;
  background: #fff;
  opacity: 0.9;
  font-size: 1.5rem;
  :disabled {
    cursor: default;
    opacity: 0.5;
  }
`;
export const HintIcon = styled(Icon)`
  position: relative;
  top: 2px;
  font-size: 1.5rem;
`;
export const ObjectiveGroupName = styled.button`
  ${({ theme, complete, expanded }) => css`
    flex: 1;
  background-color: var(--secondary-color);
    margin-right: 3rem;
    color: #fff;
    border-radius: 12px;
    align-items: center;
    padding: 0 1rem;
    height: 48px;
    cursor: pointer;
    border: none;
    display: flex;
    gap: 0.5rem;
    font-family: var(--text-font);
    font-size: 0.9rem;
    text-align: left;
    display: grid;
    grid-template-columns: 30px 1fr 20px;
    > span {
      overflow: hidden;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
    > div:last-child {
      transform: rotate(90deg);
    }
    margin-bottom: 0.5rem;
    ${expanded &&
    css`
      > div:last-child {
        transform: rotate(-90deg);
      }
    `}
    ${complete &&
    css`
      > span {
        text-decoration: line-through;
      }
    `}
  `}
`;

export const ObjectivesListWrapper = styled.div`
  display: grid;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const ListIconWrapper = styled.div`
  position: relative;
  border-radius: 60px;
  width: 32px;
  height: 32px;
  background-color: var(--pd-primary-color-lighter);
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ListIconCircleWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 100%;
  height: 100%;
`;
